angular.module('com.vmware.vsphere.client.vm').directive('vmEditSettings', [function () {
   return {
      templateUrl: 'vm-ui/resources/vm/views/settings/vmEditSettings.html',
      restrict: 'AE',
      controller: 'VmEditSettingsController',
      controllerAs: 'vmEditSettingsController'
   };
}]);
